import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getSavedSearches } from "./Services";


export const useGetSavedSearchs = () => {
  return useQuery(
    [endpoints.getSavedSearchs],
    () => getSavedSearches(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
